/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert } from 'react-bootstrap';
import { ss, url, authJsonHeader, parseTimeString, mapDispatch, getParams } from '../../utils/util';
import Highlighter from "react-highlight-words";
import FontAwesome from 'react-fontawesome';

import OzFormComponent from './OzFormComponent';
import WhereField from './WhereField';
import Loading from './Loading';
import './LeaderboardWidget.css';

import {
  listEscapes,
  getRoom,
} from '../../actions';


class LeaderboardWidget extends Component {
  state = {};

  constructor(props) {
    super(props);
    let params = getParams();
    this.state.color = params.color;
    this.state.size = params.size || this.props.size || 10;
    this.state.height = 40 + 36 * this.state.size;
  }

  componentDidMount() {
    let limit = this.state.size;
    let params = {
      room: this.props.roomId,
      didEscape: true,
      verified: true,
      limit,
    }
    let p1 = this.props.listEscapes(params, { silent: true, local: true })
      .then(resp => {
        console.log('ESCAPES resp', resp);
        this.setState({ escapes: resp.items });
      });
    let p2 = this.props.getRoom(this.props.roomId, { silent: true, local: true }, { includeDisabled: 1 })
      .then(resp => {
        this.setState({ room: resp.obj });
      });

    this.setState({ loading: true });
    Promise.all([p1, p2])
      .then(() => this.setState({ loading: false }));
  }

  showPhoto(escape, rank) {
    if (!escape.photo) return;

    this.setState({
      showingPhoto: escape,
      showingRank: rank,
    })
  }

  renderPhoto() {
    let escape = this.state.showingPhoto;
    let rank = this.state.showingRank;
    if (!escape) return;

    return (
      <div className="photo" onClick={() => this.setState({ showingPhoto: null })}>
        <div className="image" style={{ backgroundImage: 'url(' + escape.photo + ')' }} />
        <div className="caption">
          <div className="rank">#{rank}</div>
          <div className="name-time">
            <div className="name">{escape.displayName}</div>
            <div className="time">{escape.prettyTime}</div>
          </div>
        </div>
      </div>
    );
  }

  renderEscapes() {
    let escapes = this.state.escapes;
    let room = this.state.room;

    console.log('widget escapes', escapes);
    console.log('widget room', room);

    if (!escapes || !room) return;

    escapes.sort((a, b) => {
      let apt = a.prettyTime || '9999:99';
      let bpt = b.prettyTime || '9999:99';
      return apt.localeCompare(bpt);
    });

    console.log('SORTED', escapes);

    let rank = 1;
    let nodes = [];
    for (let i = 0; i < this.state.size; i++) {
      let escape = i < escapes.length ? escapes[i] : null;
      let rank = i + 1;
      let node;
      if (escape) {
        node = (
          <div className={cx('escape', { 'has-photo': !!escape.photo })} key={escape.id} onClick={() => this.showPhoto(escape, rank)}>
            <div className="rank">#{rank}</div>
            <div className="name">
              <span>{escape.displayName}</span>{' '}
              <span className="photo-icon">
                {escape.photo && <FontAwesome name="photo" />}
              </span>
            </div>
            <div className="time">{escape.prettyTime}</div>
          </div>
        );
      } else {
        node = (
          <div className="escape" key={rank}>
            <div className="rank">#{rank}</div>
            <div className="name">{' '}</div>
            <div className="time"></div>
          </div>
        );
      }
      nodes.push(node);
    }

    return (
      <div>
        <div className="room-info"><b>{room.name}</b> Leaderboard</div>
        <div className="escapes">
          {nodes}
        </div>
      </div>
    );
  }

  render() {
    let color = this.state.color || this.props.color;
    return (
      <div className={cx('LeaderboardWidget', color, { loading: this.state.loading })} style={{ height: this.state.height }}>
        {this.renderPhoto()}
        {!this.state.loading && this.renderEscapes()}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    listEscapes,
    getRoom,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LeaderboardWidget);




/** WEBPACK FOOTER **
 ** ./src/components/partials/LeaderboardWidget.js
 **/